import React, { Component } from 'react'
import Page from './Page'
import { Link } from 'react-router-dom'
import Section from './Section'
import LoadingSpinner from '../generic/LoadingSpinner'
import { Button, ButtonLink, Row, Blocker, Tip } from '../generic';
import * as variables from '../../styles/variables';
import styled from 'styled-components';
import { GuestListContainer } from '../../containers';
import checkRequiredFields from '../../helpers/check-required-fields';
import { STEPS } from './Step'

const REQUIRED_FIELDS = [
  "host_name",
  "food1",
  "topic",
  "invitation_message",
  "invitation_date",
  "invitation_start_time",
  "address_1",
  "city",
  "province",
  "postal_code",
  "signature",
  "external_rsvp",
]

const LetterContainer = styled.div`
  padding: 10px 10px 1px;
  background-color: ${variables.colours.lightGrey};
  margin-bottom: 25px;
`

class Guests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      canPublish: false,
    }
    this.props.getEvent().then(this.props.loadGuests)
    this.canPublish = this.canPublish.bind(this)
  }

  canPublish() {
    let result = true
    REQUIRED_FIELDS.forEach((field) => {
      if (!this.props.userEvent) {
        result = false

      } else {
        let fieldValue = this.props.userEvent[field]
        if (!fieldValue) {
          result = false
        } else {
          if (typeof fieldValue === "string") {
            if (fieldValue.length < 1) {
              result = false
            }
          }
        }
      }
    })
    return result
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userEvent) {
      this.setState({
        canPublish: this.canPublish(),
      })
    }
  }

  render() {
    const { userEvent, currentUser, guests } = this.props

    if (!userEvent) {
      return (<LoadingSpinner />)
    }

    const blocked = !checkRequiredFields(STEPS['how-to-invite'].requiredFields, userEvent, currentUser, {guests: guests})

    return (
      <Page {...this.props}>
        <h1>Guest List</h1>
        <p>The Guest List shows who has responded to your invitation. You can also change a guest’s RSVP status or remove a guest from the list if needed.</p>
        {blocked && 
          <Tip id="guests-block" nodismiss="true">
            <p>The Guest List is available after you have invited people in Step 4.</p>
          </Tip>
        }
        <Blocker blocked={blocked}>
          {userEvent &&
            <GuestListContainer guests={guests} event={userEvent} addGuest={this.props.addGuest} updateGuest={this.props.updateGuest} warnings={this.state.warnings} />
          }
        </Blocker>
        <ButtonLink to="/host/hub/dashboard">&lt; Go back</ButtonLink>
      </Page>
    )
  }
}

export default Guests
